import React from 'react';
import { withTheme } from 'emotion-theming';

export const ThemeContext = React.createContext({});
const { Provider } = ThemeContext;

export const HookThemeProvider = withTheme(function ProviderWrapper({ theme, children }) {
	return <Provider value={theme}>{children}</Provider>;
});
